module.exports = __webpack_public_path__ + "static/post-bank-1f889fe034e5075ec082c21049075bff.svg";